"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDetailsContainer = exports.OrderDetailsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.OrderDetailsContainer = styled_components_1.default.div `
  border: 1.5px solid green;
  border-radius: 8px;
  padding: 12px 60px 12px 60px;
  width: ${(props) => props.width};
`;
exports.StyledDetailsContainer = styled_components_1.default.div `
  margin-left: 18px;
  line-height: 28px;
`;
